import React from 'react';
import PropTypes from 'prop-types';
import { Pagination, Dropdown } from '@tfecom-thermofisher/react-komodo-design';

import { pagination as pageConstants } from 'src/constants';
import { Message } from 'src/core/components';

import messages from './messages';
import './PaginationStyle.scss';

const intervals = pageConstants.ROWS_PER_PAGE.map((value) => ({
  label: value,
  value
}));

const PaginationComponent = ({ pagination, handlePagination }) => {
  const { totalPage, pageInterval, totalItems, currentPage } = pagination;

  return (
    <div className="pagination-wrapper mt-l2">
      <div data-testid="rows-per-page-container" className="rows-per-page-container">
        <Message message={messages.resultsPerPage} />
        <Dropdown
          placeholder={pageInterval}
          options={intervals}
          onSelect={(option) => {
            handlePagination({
              currentPage,
              pageInterval: option.value
            });
          }}
        />
        <Message message={{ ...messages.resultsPerPageSeparator, values: { totalItems } }} />
      </div>
      <div data-testid="page-list-container" className="page-list-container">
        <Pagination
          currentPage={currentPage}
          totalPages={totalPage}
          action={(newPage) => {
            handlePagination({
              currentPage: newPage,
              pageInterval
            });
          }}
        />
      </div>
    </div>
  );
};

PaginationComponent.propTypes = {
  pagination: PropTypes.object,
  handlePagination: PropTypes.func
};

export default PaginationComponent;
